import {BasedataService} from "@docma-mm-core/shared/basedata.service";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {ConfigService} from "@docma-mm-core/config/config.service";
import {catchError, Observable} from "rxjs";
import {AttributeGroupData} from "@docma-mm-core/attribute-group/attribute-group";
import {Injectable} from "@angular/core";
import {AttributeGroupFile} from "@docma-mm-core/attribute-group/attribute-group-file";
import {map, switchMap} from "rxjs/operators";

@Injectable()
export class AttributeGroupApiService extends BasedataService {

  private projectUrl = '/projects/';
  private attributeGroupUrl = 'attributeGroups';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  private getProjectAttributeGroupUrl(projectId: number) {
    return super.getFullUrl(this.projectUrl + projectId + '/' + this.attributeGroupUrl);
  }

  private getProjectAttributeGroupImageUrl(attributeGroupId: number, projectId: number) {
    return super.getFullUrl('/' + this.attributeGroupUrl + '/' + attributeGroupId + '/image');
  }
  getProjectAttributeGroupList(projectId: number, top: number = 1000, skip: number = 0): Observable<AttributeGroupData> {
    const endpoint = this.getProjectAttributeGroupUrl(projectId);
    let httpParams = new HttpParams();
    if (top) {
      httpParams = httpParams.set('$top', top.toString());
    }
    if (skip) {
      httpParams = httpParams.set('$skip', skip.toString());
    }
    return this.http
      .get<AttributeGroupData>(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }

  getProjectAttributeGroupFile(attributeGroupId: number, projectId: number): Observable<{file: AttributeGroupFile, blob: Blob}> {
    const endpoint = this.getProjectAttributeGroupImageUrl(attributeGroupId, projectId);

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Accept', 'application/json');

    return this.http
      .get<any>(endpoint, { headers, responseType: 'blob' as 'json' })
      .pipe(catchError(e  => this.handleError(e)))
      .pipe(switchMap(async x => {
        return {
          file: {
            Id: x.Id,
            ImageFileName: x.ImageFileName,
            mimeType: x.type,
            buffer: await x.arrayBuffer()
          } as AttributeGroupFile,
          blob: x};
      }));
  }

}
